import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addAppointmentFailure,
  addAppointmentSuccess,
  deleteAppointmentFailure,
  deleteAppointmentSuccess,
  editAppointmentFailure,
  editAppointmentSuccess,
  fetchAppointmentsFailure,
  fetchAppointmentsSuccess,
  getViewDataFailure,
  getViewDataSuccess,
} from "./actions";
import {
  ADD_APPOINTMENT,
  DELETE_APPOINTMENT,
  EDIT_APPOINTMENT,
  FETCH_APPOINTMENTS,
  GET_VIEW_DATA,
} from "./constants";

export function* fetchAppointmentsSaga({
  payload = { cancelToken: null },
  onSuccess,
}) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload?.data ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/resident-appointment?${query}`,
      payload,
    );
    yield put(fetchAppointmentsSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(fetchAppointmentsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching appointments!"));
  }
}

export function* getViewDataSaga({
  payload = { cancelToken: null },
  onSuccess,
}) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/resident-appointment/${payload}`,
    );
    yield put(getViewDataSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addAppointmentSaga({ payload, onAdd }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/resident-appointment/add`,
      payload,
    );
    if (data) {
      yield put(successAlert("Appointment added successfully!"));
      yield put(addAppointmentSuccess());
      typeof onAdd === "function" && onAdd();
    }
  } catch (e) {
    yield put(addAppointmentFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editAppointmentSaga({ payload, onEdit }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/resident-appointment/edit/${payload.id}`,
      payload.data,
    );
    if (data) {
      yield put(successAlert("Appointment updated successfully!"));
      yield put(editAppointmentSuccess());
      typeof onEdit === "function" && onEdit(data);
    }
  } catch (e) {
    yield put(editAppointmentFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteAppointmentSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);

  try {
    const data = yield call(
      api(token).delete,
      `/api/resident-appointment/${payload}`,
    );
    if (data) {
      yield put(successAlert("Appointment deleted successfully!"));
      yield put(deleteAppointmentSuccess());
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteAppointmentFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchAppointmentsFlow() {
  yield takeEvery(FETCH_APPOINTMENTS, fetchAppointmentsSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addAppointmentFlow() {
  yield takeEvery(ADD_APPOINTMENT, addAppointmentSaga);
}
export function* editAppointmentFlow() {
  yield takeEvery(EDIT_APPOINTMENT, editAppointmentSaga);
}
export function* deleteAppointmentFlow() {
  yield takeEvery(DELETE_APPOINTMENT, deleteAppointmentSaga);
}

export default function* ResidentAppointmentSaga() {
  yield all([
    fetchAppointmentsFlow(),
    getViewDataFlow(),
    addAppointmentFlow(),
    editAppointmentFlow(),
    deleteAppointmentFlow(),
  ]);
}
